// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__IsrRm","info":"PatientInfo_info__OBIC0"};